import { useMemo } from 'react'

import { useGetInternalAnalystsQuery } from '../../../api/analysts'
import { useGetGameAnalystMapQuery } from '../../../api/games'
import { getAnalystsByAppId, sortAnalystsByName } from '../helpers/dashboardHelpers'

/** The analysts by name, `game_analyst_map` and each mapped app's analyst. */
export const useDashboardAnalysts = () => {
  const mapQuery = useGetGameAnalystMapQuery()
  const analystsQuery = useGetInternalAnalystsQuery()
  const analystMap = useMemo(() => mapQuery.data ?? {}, [mapQuery.data])
  const analysts = useMemo(() => sortAnalystsByName(analystsQuery.data ?? []), [analystsQuery.data])
  const analystsByAppId = useMemo(() => getAnalystsByAppId(analystMap, analysts), [analystMap, analysts])
  return { analystMap, analysts, analystsByAppId, isError: mapQuery.isError || analystsQuery.isError }
}
